import React from 'react';
import { Link } from 'react-router-dom';
import Form, { Actions, Password, RequiredValidator } from '../../../Components/Form';

const PasswordChallenge = ({ onSubmit, email, alreadyRegistered }) => {
    return <Form onSubmit={onSubmit}>
        {alreadyRegistered && <div className="mb-4 p-3 surface-2 rounded-lg text-sm">
            You already have an account{email && <> with <strong>{email}</strong></>}. Enter your password to log in.
        </div>}
        <Password label="Password" name="password" validators={[RequiredValidator]} />
        <Actions
            submit={{label: 'Log in'}}
            left={<Link to="/forgotten-password" state={{email}} className="inline-block mt-4 text-sm text-muted hover:text-brand">
                Forgotten your password?
            </Link>}
        />
    </Form>;
};

export default PasswordChallenge;
